import React from "react";
import "./PrimaryButton.css";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "danger" | "capture" | "disabled";
  icon?: React.ReactNode;
  loading?: boolean;
};

const PrimaryButton: React.FC<ButtonProps> = ({
  variant = "primary",
  icon,
  loading,
  children,
  ...rest
}) => {
  return (
    <button
      className={`primary-button primary-button--${variant}`}
      disabled={rest.disabled || loading}
      {...rest}
    >
      {loading ? <span className="primary-button__spinner" /> : null}
      {icon ? <span className="primary-button__icon">{icon}</span> : null}
      <span>{children}</span>
    </button>
  );
};

export default PrimaryButton;
